import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorIcon404 = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 436 344",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: 404,
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 218,
				height: 172,
				transform: "scale(2)",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Combined Shape",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M403.749 196.112H408.017C419.73 196.112 429.224 186.393 429.224 174.41C429.224 162.424 419.73 152.71 408.017 152.71H376.684C373.34 127.136 363.762 103.555 349.547 83.5886H360.367C370.258 83.5886 378.275 75.3106 378.275 65.1038C378.275 54.8922 370.258 46.6166 360.367 46.6166H312.133C287.895 29.8224 258.579 20 227 20C221.442 20 215.955 20.3042 210.553 20.8971C210.533 20.897 210.514 20.897 210.494 20.897H130.502C122.253 20.897 115.569 27.7356 115.569 36.168C115.569 44.6027 122.253 51.439 130.502 51.439H135.293C121.497 62.1402 109.576 75.1978 100.116 90.0185H63.2731C50.8269 90.0185 40.7373 100.095 40.7373 112.524C40.7373 124.954 50.8269 135.028 63.2731 135.028H80.6864C77.6266 147.169 76 159.891 76 172.998C76 182.539 76.862 191.877 78.5114 200.934H60.3932C42.5022 200.934 28 215.689 28 233.888V233.89C28 252.087 42.5022 266.841 60.3932 266.841H102.315C98.8166 268.924 96.4627 272.824 96.4627 277.289C96.4627 283.949 101.694 289.346 108.148 289.346H118.753C125.35 289.346 130.692 294.4 130.692 300.83C130.692 304.041 129.355 306.811 127.198 308.909C125.031 311 122.046 311.85 118.753 311.85H119.984C115.785 311.85 112.384 315.449 112.384 319.889C112.384 324.328 115.785 327.925 119.984 327.925H213.053C215.066 327.925 216.895 327.098 218.255 325.748C221.149 325.915 224.065 326 227 326C252.236 326 276.027 319.727 296.936 308.635H359.461C366.333 308.635 371.906 302.877 371.906 295.777C371.906 288.674 366.333 282.916 359.461 282.916H332.038C337.622 277.437 342.789 271.525 347.487 265.233H420.257C427.848 265.233 434 259.118 434 251.571C434 244.022 427.848 237.906 420.257 237.906H403.749C391.972 237.906 382.411 228.978 382.411 216.979C382.411 210.972 384.802 206.33 388.668 202.39C392.521 198.467 397.868 196.112 403.749 196.112ZM163.333 311.85C158.94 311.85 155.098 309.726 153.022 306.411C156.433 308.357 159.925 310.172 163.493 311.85H163.333Z",
				fill: "#1976D2",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 9",
				cx: 376,
				cy: 50,
				r: 20,
				fill: "#FFC46A"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group 97",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 1",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M160.742 160.957C157.901 160.957 155.068 159.977 152.903 158.031C149.631 155.074 144.299 155.074 141.018 158.031C140.458 158.536 139.573 158.505 139.053 157.966C138.533 157.418 138.564 156.559 139.128 156.054C143.446 152.157 150.475 152.157 154.797 156.054C158.074 159.01 163.41 159.01 166.687 156.054C171.008 152.157 178.038 152.157 182.355 156.054C185.637 159.01 190.968 159.01 194.245 156.054C198.567 152.157 205.596 152.157 209.918 156.054C210.483 156.563 210.51 157.418 209.989 157.966C209.465 158.51 208.589 158.536 208.024 158.031C204.747 155.074 199.412 155.074 196.139 158.031C191.817 161.928 184.788 161.932 180.47 158.031C177.189 155.074 171.858 155.074 168.581 158.031C166.415 159.977 163.583 160.957 160.742 160.957Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 3",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M291.485 108.062C289.204 108.062 287.097 108.72 285.351 109.901C284.166 108.585 282.54 107.652 280.695 107.351C280.775 106.846 280.811 106.327 280.811 105.795C280.811 99.9596 275.978 95.2178 270.003 95.2178C264.034 95.2178 259.191 99.9509 259.191 105.791C259.191 106.654 259.298 107.486 259.499 108.288C258.701 108.105 257.864 108.062 257.008 108.062C251.039 108.062 246.201 112.921 246.201 118.696H302.297C302.297 112.921 297.455 108.062 291.485 108.062Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group 7",
						children: [/* @__PURE__ */ _jsx("mask", {
							id: "mask0_2130_18810",
							style: { maskType: "alpha" },
							maskUnits: "userSpaceOnUse",
							x: 331,
							y: 50,
							width: 57,
							height: 25,
							children: /* @__PURE__ */ _jsx("path", {
								id: "Clip 6",
								fillRule: "evenodd",
								clipRule: "evenodd",
								d: "M331.878 50.041H387.938V74.1319H331.878V50.041Z",
								fill: "white"
							})
						}), /* @__PURE__ */ _jsx("g", {
							mask: "url(#mask0_2130_18810)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Fill 5",
								fillRule: "evenodd",
								clipRule: "evenodd",
								d: "M377.133 63.2201C374.858 63.2201 372.752 63.8954 371.007 65.1074C369.823 63.7568 368.198 62.7998 366.355 62.4912C366.435 61.9724 366.471 61.4358 366.471 60.8947C366.471 54.9021 361.636 50.041 355.67 50.041C349.704 50.041 344.865 54.8977 344.865 60.8902C344.865 61.7712 344.971 62.6298 345.172 63.4527C344.375 63.2649 343.538 63.2201 342.683 63.2201C336.717 63.2201 331.878 68.2065 331.878 74.1319H387.939C387.939 68.2065 383.104 63.2201 377.133 63.2201Z",
								fill: "white"
							})
						})]
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 8",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M22.0592 204.778C19.218 204.778 16.3857 203.807 14.2203 201.856C10.9478 198.903 5.61669 198.903 2.3353 201.856C1.77507 202.361 0.890248 202.335 0.370028 201.787C-0.150191 201.243 -0.119067 200.384 0.445616 199.879C4.76299 195.98 11.7926 195.985 16.1144 199.879C19.3914 202.84 24.727 202.836 28.0039 199.879C32.3257 195.985 39.3554 195.985 43.6727 199.879C46.9541 202.84 52.2853 202.836 55.5622 199.879C59.884 195.98 66.9137 195.985 71.2355 199.879C71.8002 200.384 71.8268 201.243 71.3066 201.787C70.782 202.335 69.906 202.365 69.3413 201.856C66.0644 198.903 60.7288 198.903 57.4563 201.856C53.1345 205.758 46.1049 205.758 41.7875 201.856C38.5061 198.903 33.175 198.903 29.898 201.856C27.7327 203.807 24.9004 204.778 22.0592 204.778Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 10",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M166.559 120.992L164.555 115.765C164.014 114.372 162.4 113.65 160.945 114.168L138.026 122.223L138.035 122.236C134.613 123.62 131.976 128.577 132.522 129.992C133.062 131.415 138.426 133.565 141.967 132.494L141.972 132.507L164.887 124.447C166.346 123.938 167.091 122.384 166.559 120.992Z",
						fill: "#DECBAF"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 12",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M139.714 42L121.542 48.6398L165.683 81.1304L211.92 64.2388L139.714 42Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 14",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M305.212 49.2019C305.008 48.6303 304.028 47.8786 302.468 47.0774L302.437 47.0684C301.413 46.5417 300.115 46.0016 298.635 45.4704L298.497 45.4164H298.484C297.673 45.1328 296.813 44.8448 295.887 44.5702L265.954 55.7377L265.426 46.3122L276.994 42C272.251 42.1035 267.421 42.8237 262.944 44.4937L98.2589 105.931C98.2589 105.931 89.2577 110.225 90.4942 113.632C90.9108 114.78 100.577 119.902 100.577 119.902C100.909 120.02 101.295 120.348 101.645 120.461L103.524 121.181C106.068 121.915 108.989 122.572 112.255 122.95L112.242 122.981C121.996 124.102 134.929 123.157 150.83 117.224L288.61 65.8294C297.562 62.494 304.835 55.5712 305.38 50.9574C305.455 50.3227 305.407 49.7331 305.212 49.2019Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 16",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M86.3599 76.4351L73.2369 81.1286L97.2605 106.174L130.892 94.1474L86.3599 76.4351Z",
						fill: "#21897E"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Combined Shape_2",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M264.9 45.996L276.73 41.5783C283.849 41.4261 290.773 42.6435 296.064 44.2068L265.435 55.6524L264.9 45.996ZM255.07 62.1546C256.681 61.5572 257.511 59.7598 256.916 58.1382C256.325 56.5165 254.53 55.6831 252.914 56.2806C251.303 56.878 250.473 58.6704 251.068 60.297C251.659 61.9187 253.454 62.7521 255.07 62.1546ZM247.568 61.2686C248.159 62.8903 247.333 64.6876 245.718 65.2851C244.102 65.8825 242.312 65.0491 241.717 63.4275C241.127 61.8008 241.952 60.0084 243.567 59.411C245.183 58.8136 246.973 59.647 247.568 61.2686ZM236.366 69.9807C237.982 69.3833 238.812 67.5859 238.217 65.9643C237.627 64.3426 235.831 63.5092 234.22 64.1067C232.605 64.7041 231.774 66.4964 232.369 68.1231C232.96 69.7448 234.755 70.5782 236.366 69.9807ZM228.868 69.0954C229.463 70.7175 228.633 72.5155 227.018 73.1131C225.403 73.7057 223.613 72.8771 223.018 71.2549C222.428 69.6277 223.253 67.8348 224.868 67.2372C226.483 66.6395 228.273 67.4732 228.868 69.0954ZM216.112 76.2436C217.723 75.646 218.553 73.848 217.963 72.2258C217.368 70.6036 215.572 69.7699 213.962 70.3676C212.347 70.9602 211.517 72.7582 212.112 74.3804C212.702 76.0076 214.497 76.8362 216.112 76.2436ZM208.613 75.3513C209.203 76.9785 208.378 78.7764 206.762 79.374C205.147 79.9667 203.356 79.138 202.761 77.5108C202.171 75.8886 202.996 74.0907 204.611 73.4981C206.227 72.9004 208.017 73.7341 208.613 75.3513ZM197.414 84.0702C199.024 83.4725 199.854 81.6744 199.264 80.0471C198.669 78.4298 196.874 77.5961 195.264 78.1937C193.649 78.7864 192.818 80.5845 193.414 82.2068C194.004 83.8291 195.799 84.6629 197.414 84.0702ZM189.912 83.1783C190.507 84.8063 189.677 86.6051 188.062 87.198C186.447 87.7959 184.657 86.9618 184.062 85.3389C183.472 83.7159 184.297 81.9171 185.912 81.3242C187.527 80.7263 189.322 81.5604 189.912 83.1783ZM178.715 90.3304C180.325 89.7373 181.155 87.9329 180.565 86.3094C179.97 84.691 178.175 83.8566 176.565 84.4548C174.95 85.0478 174.12 86.8472 174.715 88.4707C175.305 90.0941 177.1 90.9234 178.715 90.3304Z",
						fill: "#21897E"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 38",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M202.308 98.0585L169.847 131.218L193.936 122.323L252.434 79.5654L202.308 98.0585Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 40",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M100.167 113.007L97.8623 113.425C97.7968 113.439 97.7361 113.392 97.7314 113.327C97.7174 113.27 97.7594 113.209 97.8202 113.2C97.8249 113.2 97.8296 113.195 97.8342 113.195L100.167 113.007Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 42",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M88.5323 116.072L84.8963 117.612C84.6022 117.734 84.2775 117.542 84.1744 117.18C84.0751 116.814 84.2317 116.42 84.5258 116.293C84.5411 116.288 84.5525 116.283 84.5678 116.279L88.2841 115.063C88.5094 114.992 88.7462 115.161 88.8035 115.438C88.8646 115.706 88.7424 115.978 88.5323 116.072Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 44",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M77.3768 120.864L73.364 123.056C72.7978 123.357 72.1058 123.132 71.8137 122.54C71.5126 121.953 71.7328 121.225 72.299 120.92C72.3215 120.906 72.3484 120.892 72.3709 120.882L76.514 118.985C77.0173 118.755 77.6059 118.995 77.8306 119.525C78.0373 120.028 77.8351 120.615 77.3768 120.864Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 46",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M64.886 127.169L61.4218 129.414C60.7851 129.833 59.9096 129.684 59.4614 129.084C59.0216 128.487 59.1808 127.663 59.8175 127.251C59.8384 127.239 59.8636 127.224 59.8845 127.212L63.466 125.136C64.0776 124.786 64.8776 124.963 65.2546 125.532C65.6149 126.085 65.4515 126.8 64.886 127.169Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 48",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M54.0232 135.685L50.9612 138.608C50.2969 139.247 49.2843 139.172 48.7051 138.454C48.1178 137.731 48.1867 136.629 48.8509 135.989C48.8631 135.981 48.8793 135.963 48.8955 135.95L52.0588 133.155C52.7109 132.578 53.6668 132.683 54.1974 133.393C54.7159 134.09 54.6308 135.099 54.0232 135.685Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 50",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M46.141 144.227L42.6748 147.782C41.834 148.643 40.4623 148.653 39.6068 147.807C38.7513 146.96 38.7365 145.574 39.5773 144.717L39.6166 144.678L43.1664 141.207C44.0022 140.395 45.3396 140.41 46.1508 141.251C46.9522 142.083 46.9424 143.405 46.141 144.227Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 52",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M36.873 155.055L33.7365 158.595C32.9157 159.529 31.4501 159.661 30.4583 158.888C29.4568 158.12 29.32 156.738 30.1456 155.81C30.1505 155.801 30.1701 155.782 30.1798 155.773L33.4043 152.297C34.23 151.409 35.6663 151.318 36.6141 152.086C37.5521 152.846 37.6596 154.168 36.873 155.055Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 54",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M27.7182 164.228L25.4526 167.84C24.8447 168.812 23.6086 169.075 22.7007 168.427C21.7848 167.779 21.5416 166.466 22.1496 165.489L22.1577 165.476L24.4475 161.881C25.0595 160.918 26.2835 160.667 27.1873 161.32C28.083 161.968 28.314 163.264 27.7182 164.228Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 56",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M21.614 176.379L19.7513 180.121C19.2461 181.141 17.9458 181.588 16.8475 181.117C15.7536 180.646 15.2792 179.428 15.7844 178.404L17.6427 174.666C18.1479 173.642 19.4482 173.195 20.5465 173.666C21.6404 174.137 22.1192 175.355 21.614 176.375V176.379Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 58",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M17.0963 188.809L16.6727 191.142L16.3781 193.309L16.3619 193.447C16.1925 194.699 15.1918 195.562 14.1224 195.363C13.0572 195.164 12.3268 193.997 12.4882 192.745C12.4882 192.745 12.6536 191.469 12.8151 190.198C13.0208 189.027 13.2266 187.86 13.2266 187.86C13.4486 186.603 14.4896 185.788 15.559 186.049C16.6283 186.309 17.3183 187.528 17.1004 188.79L17.0963 188.809Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 60",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M16.2021 200.411C16.2021 200.411 16.384 201.603 16.5658 202.805C16.799 203.843 17.0322 204.88 17.0322 204.88L17.0757 205.069C17.3405 206.272 16.7713 207.503 15.7911 207.832C14.8266 208.157 13.8305 207.474 13.5499 206.305C13.5499 206.305 13.2336 205.001 12.9214 203.697C12.7119 202.505 12.5063 201.312 12.5063 201.312C12.2929 200.062 12.9451 198.84 13.9609 198.573C14.9768 198.307 15.9768 199.102 16.1942 200.353C16.1942 200.362 16.1982 200.391 16.2021 200.411Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 62",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M20.9702 211.849C20.9702 211.849 21.161 212.089 21.4545 212.441C21.5963 212.622 21.7627 212.832 21.9437 213.057L22.2274 213.404L22.2959 213.492L22.3008 213.502H22.3057C22.247 213.438 22.4427 213.654 22.1736 213.36L22.1785 213.37L22.1981 213.385L22.2421 213.424L22.4035 213.585C22.6188 213.805 22.834 214.025 23.0346 214.235C23.2449 214.455 23.3672 214.499 23.514 214.622C23.7684 214.832 23.9396 214.974 23.9396 214.974L24.15 215.145C25.055 215.869 25.192 217.189 24.4679 218.088C23.7488 218.978 22.4573 219.125 21.5523 218.44C21.5523 218.44 21.2441 218.196 20.7745 217.839C20.5641 217.663 20.2315 217.423 20.0407 217.228C19.8352 217.027 19.6151 216.807 19.3949 216.592L19.2335 216.431L18.94 216.108L18.6514 215.776C18.4655 215.556 18.2942 215.345 18.1475 215.174C17.8442 214.817 17.6485 214.587 17.6485 214.587C16.8805 213.678 16.9979 212.319 17.9029 211.551C18.8079 210.783 20.1679 210.901 20.9359 211.805C20.9408 211.815 20.9604 211.835 20.9702 211.849Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group 66",
						children: [/* @__PURE__ */ _jsx("mask", {
							id: "mask1_2130_18810",
							style: { maskType: "alpha" },
							maskUnits: "userSpaceOnUse",
							x: 28,
							y: 215,
							width: 10,
							height: 6,
							children: /* @__PURE__ */ _jsx("path", {
								id: "Clip 65",
								fillRule: "evenodd",
								clipRule: "evenodd",
								d: "M28.7634 215.927H37.2684V220.435H28.7634V215.927Z",
								fill: "white"
							})
						}), /* @__PURE__ */ _jsx("g", {
							mask: "url(#mask1_2130_18810)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Fill 64",
								fillRule: "evenodd",
								clipRule: "evenodd",
								d: "M30.5747 216.598C30.5747 216.598 31.7434 216.532 32.9121 216.462L35.0203 216.156L35.1606 216.138C36.1703 215.992 37.1006 216.696 37.2502 217.706C37.3904 218.706 36.7079 219.631 35.7262 219.8L33.1879 220.218C32.0145 220.321 30.8412 220.425 30.8412 220.425C29.7894 220.514 28.8638 219.734 28.7703 218.678C28.6815 217.626 29.4575 216.696 30.5046 216.607C30.5186 216.607 30.5373 216.602 30.5513 216.602L30.5747 216.598Z",
								fill: props.fill
							})
						})]
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 67",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M43.1046 214.436L47.4772 212.739C48.3269 212.408 49.3246 212.731 49.7113 213.457C50.0931 214.167 49.7303 215.012 48.9141 215.355L44.594 217.154C43.7299 217.514 42.675 217.207 42.2501 216.461C41.8253 215.718 42.1881 214.82 43.0569 214.461C43.0712 214.453 43.0951 214.445 43.1046 214.436Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 69",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M55.1412 207.204L58.726 204.988C59.3227 204.622 60.1314 204.758 60.5422 205.291C60.94 205.816 60.8059 206.52 60.2438 206.897L56.7498 209.23C56.1358 209.643 55.2666 209.53 54.8126 208.974C54.3542 208.418 54.4839 207.64 55.098 207.232C55.1109 207.22 55.1282 207.212 55.1412 207.204Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 71",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M64.3183 199.858L68.0667 197.205C68.5712 196.849 69.343 196.88 69.8021 197.268C70.2461 197.647 70.2209 198.226 69.7567 198.582L66.1546 201.352C65.635 201.755 64.7925 201.751 64.2729 201.348C63.7583 200.941 63.7583 200.288 64.2779 199.889C64.293 199.877 64.3082 199.869 64.3183 199.858Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 73",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M75.0391 190.968L78.0824 187.803C78.3629 187.518 78.8443 187.485 79.1669 187.728C79.4801 187.96 79.5269 188.372 79.2791 188.653L76.4229 191.951C76.1237 192.297 75.5674 192.363 75.1747 192.099C74.7867 191.839 74.7119 191.348 75.0111 191.001C75.0158 190.993 75.0298 190.977 75.0391 190.968Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 75",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M83.3332 180.545L85.8575 176.783C85.9744 176.606 86.2221 176.557 86.4091 176.668C86.5915 176.774 86.6475 177 86.5447 177.173L84.2261 181.054C84.0858 181.294 83.7679 181.373 83.5155 181.241C83.2631 181.108 83.1789 180.811 83.3192 180.567C83.3238 180.563 83.3285 180.554 83.3332 180.545Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 79",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M66.0611 116.982C66.0611 116.982 65.6357 117.418 65.2103 117.85L64.3361 118.672C64.079 118.912 63.6817 118.902 63.4386 118.644C63.2049 118.39 63.2189 117.991 63.4713 117.747C63.5461 117.677 63.6349 117.63 63.7284 117.601C63.7284 117.601 64.3034 117.437 64.8831 117.273C65.4721 117.122 66.0611 116.982 66.0611 116.982Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 81",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M58.4935 125.051L55.1024 127.614C54.1395 128.345 52.7211 128.215 51.932 127.318C51.1429 126.422 51.2838 125.108 52.2514 124.377C52.3265 124.316 52.4158 124.259 52.5003 124.211L56.2343 122.092C57.1549 121.57 58.362 121.84 58.9256 122.697C59.4423 123.48 59.2403 124.481 58.4935 125.051Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 83",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M48.9385 131.663L45.3584 133.99C44.461 134.574 43.1782 134.429 42.4954 133.667C41.871 132.98 41.954 132.023 42.6368 131.415C42.6368 131.415 42.8368 131.241 43.1294 130.98C43.4367 130.715 43.8464 130.363 44.2512 130.015C45.0609 129.336 45.8754 128.657 45.8754 128.657C46.8021 127.887 48.2849 127.9 49.1921 128.682C50.0993 129.469 50.0847 130.727 49.1628 131.502C49.0945 131.56 49.0116 131.618 48.9385 131.663Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 85",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M39.0558 139.768C39.0558 139.768 38.5556 140.097 38.0507 140.435C37.5318 140.745 37.0083 141.055 37.0083 141.055C37.0083 141.055 37.2841 140.51 37.5646 139.97L38.1583 138.923C38.3312 138.613 38.7192 138.505 39.0231 138.684C39.3316 138.857 39.4344 139.247 39.2615 139.552C39.2101 139.642 39.1399 139.717 39.0558 139.768Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 87",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M87.8173 124.977C87.8173 124.977 87.3451 125.344 86.873 125.705C86.4055 126.076 85.9193 126.419 85.9193 126.419C85.6949 126.569 85.3864 126.508 85.2321 126.283C85.0779 126.057 85.1386 125.752 85.363 125.602C85.4051 125.569 85.4565 125.546 85.5033 125.532C85.5033 125.532 86.0689 125.367 86.6579 125.245L87.8173 124.977Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 89",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M78.8526 130.567C78.8526 130.567 78.1069 131.054 77.3612 131.545C76.6155 132.036 75.8618 132.515 75.8618 132.515C75.0804 133.01 74.0253 132.799 73.5136 132.044C73.002 131.284 73.2201 130.268 74.0015 129.773C74.065 129.734 74.1404 129.692 74.2038 129.662C74.2038 129.662 75.0209 129.29 75.842 128.929C76.6631 128.568 77.4842 128.208 77.4842 128.208C78.1902 127.901 79.0232 128.2 79.3445 128.883C79.6301 129.493 79.4119 130.199 78.8526 130.567Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 91",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M69.1425 136.603C69.1425 136.603 68.3018 137.133 67.4567 137.668C66.6071 138.189 65.7575 138.707 65.7575 138.707C64.729 139.334 63.3562 139.06 62.69 138.093C62.0237 137.138 62.3099 135.858 63.307 135.223C63.307 135.223 64.1522 134.693 64.9884 134.159C65.8424 133.637 66.692 133.119 66.692 133.119C67.7205 132.492 69.0933 132.766 69.764 133.734C70.4213 134.689 70.1441 135.968 69.1425 136.603Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 93",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M58.4251 144.286C58.4251 144.286 57.6444 144.882 56.8387 145.455C56.0455 146.033 55.2441 146.605 55.2441 146.605C54.5588 147.103 53.6535 146.878 53.2133 146.103C52.8188 145.408 52.9393 144.512 53.4625 143.972C53.4625 143.972 54.1602 143.254 54.862 142.531C55.5555 141.808 56.2656 141.103 56.2656 141.103C57.0048 140.376 58.1302 140.46 58.7739 141.296C59.4176 142.136 59.347 143.404 58.6037 144.136C58.5497 144.188 58.4832 144.244 58.4251 144.286Z",
						fill: props.fill
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Fill 95",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M48.4502 150.656C48.4502 150.656 47.9501 150.971 47.4171 151.253L46.37 151.83C46.37 151.83 46.7253 151.342 47.0806 150.863C47.4265 150.37 47.8051 149.914 47.8051 149.914C47.9828 149.703 48.296 149.675 48.5063 149.853C48.7167 150.027 48.7401 150.346 48.5671 150.558C48.5344 150.59 48.4923 150.628 48.4502 150.656Z",
						fill: props.fill
					})
				]
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group 125",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group 46",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "Fill 1_2",
							fillRule: "evenodd",
							clipRule: "evenodd",
							d: "M324.288 233.493C318.514 233.493 313.817 238.364 313.817 244.345V244.619C313.817 250.603 318.514 255.467 324.288 255.467H331.621C337.391 255.467 342.088 250.603 342.088 244.619V244.345C342.088 238.364 337.391 233.493 331.621 233.493H324.288ZM331.621 260.96H324.288C315.591 260.96 308.516 253.629 308.516 244.619V244.345C308.516 235.332 315.591 228 324.288 228H331.621C340.314 228 347.389 235.332 347.389 244.345V244.619C347.389 253.629 340.314 260.96 331.621 260.96Z",
							fill: "#7B6551"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Fill 3_2",
							fillRule: "evenodd",
							clipRule: "evenodd",
							d: "M297.584 322C297.584 325.371 295.044 328.102 291.913 328.102H281.388C278.258 328.102 275.718 325.371 275.718 322C275.718 318.625 278.258 315.895 281.388 315.895H291.913C295.044 315.895 297.584 318.625 297.584 322Z",
							fill: "#7B6551"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Fill 5_2",
							fillRule: "evenodd",
							clipRule: "evenodd",
							d: "M378.972 322C378.972 325.371 376.435 328.102 373.304 328.102H362.775C359.643 328.102 357.107 325.371 357.107 322C357.107 318.625 359.643 315.895 362.775 315.895H373.304C376.435 315.895 378.972 318.625 378.972 322Z",
							fill: "#7B6551"
						}),
						/* @__PURE__ */ _jsxs("g", {
							id: "Group 9",
							children: [/* @__PURE__ */ _jsx("mask", {
								id: "mask2_2130_18810",
								style: { maskType: "alpha" },
								maskUnits: "userSpaceOnUse",
								x: 266,
								y: 242,
								width: 123,
								height: 81,
								children: /* @__PURE__ */ _jsx("path", {
									id: "Clip 8",
									fillRule: "evenodd",
									clipRule: "evenodd",
									d: "M266.303 242.955H388.548V322.34H266.303V242.955Z",
									fill: "white"
								})
							}), /* @__PURE__ */ _jsx("g", {
								mask: "url(#mask2_2130_18810)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Fill 7",
									fillRule: "evenodd",
									clipRule: "evenodd",
									d: "M382.886 322.34H271.968C268.837 322.34 266.303 319.802 266.303 316.675V248.619C266.303 245.492 268.837 242.955 271.968 242.955H382.886C386.013 242.955 388.551 245.492 388.551 248.619V316.675C388.551 319.802 386.013 322.34 382.886 322.34Z",
									fill: "#FFF7DB"
								})
							})]
						}),
						/* @__PURE__ */ _jsxs("g", {
							id: "Group 12",
							children: [/* @__PURE__ */ _jsx("mask", {
								id: "mask3_2130_18810",
								style: { maskType: "alpha" },
								maskUnits: "userSpaceOnUse",
								x: 266,
								y: 316,
								width: 123,
								height: 7,
								children: /* @__PURE__ */ _jsx("path", {
									id: "Clip 11",
									fillRule: "evenodd",
									clipRule: "evenodd",
									d: "M266.303 316.493H388.548V322.323H266.303V316.493Z",
									fill: "white"
								})
							}), /* @__PURE__ */ _jsx("g", {
								mask: "url(#mask3_2130_18810)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Fill 10_2",
									fillRule: "evenodd",
									clipRule: "evenodd",
									d: "M382.886 322.323H271.968C268.837 322.323 266.303 319.737 266.303 316.551V316.493H388.551V316.551C388.551 319.737 386.013 322.323 382.886 322.323Z",
									fill: "#373430"
								})
							})]
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Fill 13",
							fillRule: "evenodd",
							clipRule: "evenodd",
							d: "M296.369 321.998H306.087V242.649H296.369V321.998Z",
							fill: "#6E82B0"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Fill 15",
							fillRule: "evenodd",
							clipRule: "evenodd",
							d: "M349.818 321.998H359.536V242.649H349.818V321.998Z",
							fill: "#6E82B0"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Fill 16_2",
							fillRule: "evenodd",
							clipRule: "evenodd",
							d: "M266 303.687V317.496C266 320.655 268.548 323.219 271.692 323.219H285.436C285.436 312.43 276.734 303.687 266 303.687Z",
							fill: "#3D507A"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Fill 17",
							fillRule: "evenodd",
							clipRule: "evenodd",
							d: "M388.69 303.687C377.953 303.687 369.254 312.43 369.254 323.219H382.995C386.139 323.219 388.69 320.655 388.69 317.496V303.687Z",
							fill: "#3D507A"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Fill 19",
							fillRule: "evenodd",
							clipRule: "evenodd",
							d: "M365.292 244.573V254.994C365.292 259.477 368.432 263.319 372.444 263.4C376.531 263.485 379.87 259.809 379.87 255.263V244.573C379.87 242.837 378.608 241.428 377.056 241.428H368.109C366.554 241.428 365.292 242.837 365.292 244.573Z",
							fill: "#7B6551"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Fill 28",
							fillRule: "evenodd",
							clipRule: "evenodd",
							d: "M274.821 244.573V254.994C274.821 259.477 277.961 263.319 281.972 263.4C286.06 263.485 289.398 259.809 289.398 255.263V244.573C289.398 242.837 288.137 241.428 286.585 241.428H277.637C276.082 241.428 274.821 242.837 274.821 244.573Z",
							fill: "#7B6551"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Fill 21",
							fillRule: "evenodd",
							clipRule: "evenodd",
							d: "M374.693 255.667C374.693 257.016 373.603 258.112 372.265 258.112C370.923 258.112 369.834 257.016 369.834 255.667C369.834 254.321 370.923 253.229 372.265 253.229C373.603 253.229 374.693 254.321 374.693 255.667Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Fill 29",
							fillRule: "evenodd",
							clipRule: "evenodd",
							d: "M284.221 255.667C284.221 257.016 283.132 258.112 281.793 258.112C280.452 258.112 279.362 257.016 279.362 255.667C279.362 254.321 280.452 253.229 281.793 253.229C283.132 253.229 284.221 254.321 284.221 255.667Z",
							fill: "white"
						})
					]
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "CUSTOM BRANDED",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M352.092 120.958C351.517 124.221 353.695 127.333 356.958 127.908C360.221 128.483 363.333 126.305 363.908 123.042C364.483 119.779 362.305 116.667 359.042 116.092C355.779 115.517 352.667 117.695 352.092 120.958ZM338.479 143.954C336.848 143.666 335.758 142.111 336.046 140.479C336.334 138.848 337.889 137.758 339.521 138.046C341.152 138.334 342.242 139.889 341.954 141.521C341.666 143.152 340.111 144.242 338.479 143.954ZM256.043 181.497V194.299C256.043 199.854 255.448 204.646 254.259 208.676C253.071 212.673 251.355 215.958 249.113 218.532C246.905 221.072 244.273 222.952 241.216 224.171C238.159 225.39 234.762 226 231.025 226C228.036 226 225.251 225.627 222.669 224.882C220.088 224.103 217.761 222.901 215.689 221.275C213.651 219.65 211.885 217.601 210.39 215.128C208.929 212.622 207.808 209.642 207.027 206.187C206.246 202.733 205.855 198.77 205.855 194.299V181.497C205.855 175.943 206.45 171.184 207.639 167.222C208.861 163.225 210.577 159.957 212.785 157.417C215.027 154.877 217.676 153.014 220.733 151.829C223.79 150.61 227.187 150 230.924 150C233.913 150 236.681 150.389 239.229 151.168C241.81 151.914 244.137 153.082 246.209 154.674C248.281 156.266 250.047 158.315 251.508 160.821C252.969 163.293 254.09 166.257 254.871 169.711C255.652 173.132 256.043 177.061 256.043 181.497ZM241.318 196.23V179.516C241.318 176.84 241.165 174.504 240.859 172.505C240.587 170.507 240.163 168.814 239.585 167.425C239.008 166.003 238.295 164.851 237.445 163.971C236.596 163.09 235.628 162.447 234.541 162.04C233.454 161.634 232.248 161.43 230.924 161.43C229.259 161.43 227.782 161.752 226.491 162.396C225.234 163.039 224.164 164.072 223.281 165.495C222.398 166.883 221.718 168.746 221.243 171.083C220.801 173.386 220.58 176.197 220.58 179.516V196.23C220.58 198.906 220.716 201.259 220.988 203.291C221.294 205.324 221.735 207.068 222.313 208.524C222.924 209.947 223.637 211.115 224.453 212.029C225.302 212.91 226.27 213.553 227.357 213.96C228.478 214.366 229.701 214.57 231.025 214.57C232.656 214.57 234.1 214.248 235.356 213.604C236.647 212.927 237.734 211.877 238.617 210.455C239.534 208.998 240.214 207.102 240.655 204.765C241.097 202.428 241.318 199.583 241.318 196.23ZM198.162 197.348V208.829H189.755V224.984H175.081V208.829H144.713L144 199.939L174.928 151.016H175.081H186.596H189.755V197.348H198.162ZM173.96 172.099L175.081 170.229V197.348H158.572L173.96 172.099ZM318 208.829V197.348H309.593V151.016H306.434H294.919H294.766L263.838 199.939L264.552 208.829H294.919V224.984H309.593V208.829H318ZM294.919 170.229L293.798 172.099L278.411 197.348H294.919V170.229ZM97.4452 187.273C104.19 185.007 107.668 178.123 105.213 171.897C102.758 165.671 95.3001 162.461 88.5549 164.727C81.8096 166.993 78.3324 173.877 80.7874 180.103C83.2418 186.329 90.7 189.539 97.4452 187.273Z",
				fill: props.fill
			})
		]
	})
});
export default SvgErrorIcon404;
